import { render, staticRenderFns } from "./No08.vue?vue&type=template&id=6c975e3e&scoped=true"
import script from "./No08.vue?vue&type=script&lang=js"
export * from "./No08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c975e3e",
  null
  
)

export default component.exports